module.exports = __webpack_public_path__ + "static/img/banner1.8c33326.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner1.jpg
// module id = fV7v
// module chunks = 0